module.exports = __webpack_public_path__ + "static/media/HTC_Space32_Visual.6fd92612.jpg";